// extracted by mini-css-extract-plugin
export var background = "dN_4";
export var close = "dN_kS";
export var content = "dN_cH";
export var frame = "dN_kN";
export var menuBackground = "dN_kQ";
export var menuContent = "dN_kR";
export var open = "dN_kP";